import React from 'react';
import { Link } from 'react-router-dom';
import {
  Avatar,
  IconButton,
  Icon,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Grid,
  Typography,
  withStyles,
} from '@material-ui/core';
import { IconUI, ToggleUI } from '../../common';

const PreguntasList_ = (props) => {
  let { preguntas, classes } = props;

  const renderizarPreguntas = () => {
    if (preguntas && preguntas.length > 0) {
      return preguntas.map((pregunta, index) => {
        return (
          <ListItem
            divider={index < preguntas.length - 1}
            key={pregunta.slug}
            classes={{ root: classes.list_item }}
          >
            <Link
              to={{ pathname: '/soporte/' + pregunta.slug }}
              style={{ width: '100%' }}
            >
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                    spacing={8}
                  >
                    <Grid item xs={9}>
                      <Grid container alignItems="center" spacing={8}>
                        <ToggleUI show={pregunta.icon ? true : false}>
                          <Grid item>
                            <ListItemAvatar>
                              <Avatar className={classes.avatar}>
                                <IconUI
                                  name={pregunta.icon}
                                  style={{
                                    fontSize: '1rem',
                                    textAlign: 'center',
                                  }}
                                />
                              </Avatar>
                            </ListItemAvatar>
                          </Grid>
                        </ToggleUI>
                        <Grid item>
                          <Typography className={classes.list_item_title}>
                            {pregunta.title}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <IconButton aria-label="Aceptar">
                        <Icon
                          style={{
                            fontSize: '1.5rem',
                            textAlign: 'center',
                          }}
                        >
                          navigate_next
                        </Icon>
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Link>
          </ListItem>
        );
      });
    } else {
      return (
        <ListItem>
          <ListItemText primary="No hay preguntas disponibles en esta sección" />
        </ListItem>
      );
    }
  };

  return <List classes={{ root: classes.list }}>{renderizarPreguntas()}</List>;
};

const styles = (theme) => ({
  list: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '0',
    '&:last-child': {
      borderBottom: '0px solid transparent',
    },
  },
  list_item: {
    padding: '5px 0px 5px 0px',
  },
  list_item_title: {
    fontSize: '1rem',
    marginLeft: '10px',
    marginBottom: '0px',
    padding: '0px',
    fontWeight: '500',
  },
  avatar: {
    marginLeft: '10px',
  },
});

export const PreguntasList = withStyles(styles, { withTheme: true })(
  PreguntasList_
);
